import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    name: yup.string().trim().label('Business Name').required()
  });
};
